
import { Dispatch, SetStateAction } from 'react';
import MyModal from '../../../../components/Modal';

export default function SendEmailsModal({
  sendEmailsModalShow,
  setSendEmailsModalShow,
  sendEmails,
}: {
  sendEmailsModalShow: boolean;
  setSendEmailsModalShow: Dispatch<SetStateAction<boolean>>;
  sendEmails: () => void;
}) {
  return (
    <MyModal
      show={sendEmailsModalShow}
      title={'Enviar e-mails'}
      closeButtonLabel="Fechar"
      actionButtonLabel={'Confirmar'}
      onClose={() => setSendEmailsModalShow(false)}
      onAction={() => sendEmails()}
      type='action'
      modalBody={(
        <>
              Tem certeza que deseja enviar e-mails com notificação de resultado finalizado para todos os funcionários que possuem consultas dentro do arquivo selecionado? ATENÇÃO: Isto será cobrado.
        </>
      )}
    />
  );
}
